import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import {
  callToCreateDealerAction,
  setIsCreateDealerActionCompleted,
  setIsCreateDealerActionInprogress
} from '@/explore/ducks/slice';
import { useDispatch } from 'react-redux';
import {
  getIsCreateDealerActionCompleted,
  getIsCreateDealerActionInprogress
} from '@/explore/ducks/selectors';
import { operationalStatusUpdateType } from '@/explore/types';
import { DealerProfileType } from '@masterffl/dealer-profile-component';

type Props = {
  open: boolean;
  close: () => void;
  details: DealerProfileType;
};

const getValue = (
  status: DealerProfileType['businessDetails']
): operationalStatusUpdateType['value'] => {
  if (status?.isPermanentlyClosed) return 'permanent';
  else if (status?.isTemporarilyClosed) return 'temporary';
  else return 'operational';
};

const UpdateClosedStatusModal = ({ open, close, details }: Props) => {
  const [status, setStatus] =
    useState<operationalStatusUpdateType['value']>(getValue(details.businessDetails));
  const [areValuesChanged, setAreValueChanged] = useState(false);
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    const payload: operationalStatusUpdateType = {
      name: 'closeStatus',
      license_key: details.primaryInboundDetails.licenseKey,
      type: 'add',
      value: status
    };

    dispatch(
      callToCreateDealerAction({
        operationalStatusUpdate: [payload]
      })
    );
  };

  const handleValueChange = (value: operationalStatusUpdateType['value']) => {
    setStatus(value);
    if (details) {
      if (value === getValue(details.businessDetails)) {
        setAreValueChanged(false)
      }
        
      else setAreValueChanged(true);
    }
  };


  useEffect(() => {
    if (!isCreateDealerActionInprogress && isCreateDealerActionCompleted) {
      close();
      dispatch(setIsCreateDealerActionCompleted(false));
    }
  }, [isCreateDealerActionInprogress, isCreateDealerActionCompleted]);

  useEffect(() => {
    if (details) setStatus(getValue(details.businessDetails));
  }, [open, details]);
  return (
    <Modal closeOnOverlayClick={false} isOpen={open} onClose={close} isCentered>
      <ModalOverlay />
      <ModalContent
        className={`transfer-create-modal`}
        maxWidth={'350px'}
        maxHeight={'90vh'}
        scrollBehavior={'auto'}
      >
        <ModalHeader className="store-contact-details-edit-header">
          Edit Operational Status
          <button className="transfer-create-modal__close-btn" onClick={close}>
            <img src="/images/ui/close.svg" />
          </button>
        </ModalHeader>
        <ModalBody className={'store-contact-details-edit-body'}>
          <Flex>
            <RadioGroup
              value={status}
              onChange={handleValueChange}
              defaultValue="1"
            >
              <Stack spacing={4}>
                <Radio value="temporary">Temporary Closed</Radio>
                <Radio value="permanent">Permanently Closed</Radio>
                <Radio value="operational">Operational</Radio>
              </Stack>
            </RadioGroup>
          </Flex>
        </ModalBody>
        <ModalFooter className={`store-contact-details-edit-footer`}>
          <Button
            colorScheme="blue"
            onClick={close}
            background="#ffffff"
            color="#0C1E46"
            border="1px solid #0C1E46"
            padding="8px 11px"
            fontSize={'16px'}
            marginRight="20px"
            height={'35px'}
            width={'100px'}
            isDisabled={isCreateDealerActionInprogress}
          >
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            background="#0C1E46"
            height={'35px'}
            width={'100px'}
            fontSize={'16px'}
            padding="8px 20px"
            onClick={handleSubmit}
            isDisabled={!areValuesChanged}
            isLoading={isCreateDealerActionInprogress}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default UpdateClosedStatusModal;
